// extracted by mini-css-extract-plugin
module.exports = {"typing-loader":"TypingLoader_typing-loader__1VCgu","typing-loader__dot":"TypingLoader_typing-loader__dot__4FSKJ","wave":"TypingLoader_wave__SIluY"};